<template>
  <div class="home-container">
    <el-aside :width="isCollapse ? '64px' : '220px'" class="home-aside" :class="{ 'is-collapse': isCollapse }">
      <!-- Logo + 用户信息 -->
      <div class="aside-header">
        <!-- Logo区域 -->
        <div class="logo">
          <div class="logo-icon-wrapper">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
          <span class="logo-text" v-show="!isCollapse">智课通</span>
          <!-- 收缩状态下的收缩按钮 -->
          <div class="collapse-btn-wrapper" v-show="isCollapse" @click="toggleCollapse" title="展开">
            <div class="collapse-btn">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
              </svg>
            </div>
          </div>
        </div>
        <!-- 用户信息区域 -->
        <div class="user-info-card" v-show="!isCollapse">
          <div class="user-info-header">
            <div class="user-avatar-wrapper">
              <img v-if="userInfo.auHeader" :src="userInfo.auHeader" class="user-avatar-img" alt="头像">
              <span v-else class="user-avatar-text">{{ getAvatarText(userInfo.auName) }}</span>
            </div>
            <div class="user-text">
              <div class="user-name">{{ userInfo.auName || '用户' }}</div>
              <div class="user-role-row">
                <span class="post-badge" :class="'post-' + (userInfo.auPost || 0)">{{ userInfo.auPostName || '系统管理员' }}</span>
              </div>
            </div>
          </div>
          <!-- 操作按钮组 -->
          <div class="action-buttons-group">
            <div class="action-btn password-btn" @click="openPasswordDialog">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
              </svg>
              <span>修改密码</span>
            </div>
            <div class="action-btn logout-btn" @click="Out">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
              </svg>
              <span>退出登录</span>
            </div>
          </div>
          <!-- 收缩按钮 -->
          <div class="collapse-btn-wrapper">
            <div class="collapse-btn" @click="toggleCollapse" :title="isCollapse ? '展开' : '收起'">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Element-UI 菜单组件（修复点击+还原图3样式） -->
      <el-menu :default-active="$route.name" class="aside-menu" text-color="#666" active-text-color="#409EFF"
        unique-opened @select="handleMenuSelect" ref="menuRef" router :collapse="isCollapse">
        <template v-for="(item, index) in myRouter || []">
          <el-menu-item :key="item.authId || index" :index="item.authRemark.substring(1)" :route="item.authUrl" v-if="!item.children">
            <i :class="item.authIcon"></i>
            <span slot="title">{{ item.authName }}</span>
          </el-menu-item>
          <el-submenu :key="'sub-' + (item.authId || index)" :index="`${index}`" v-if="item.children && item.children.length > 0">
            <template slot="title">
              <i :class="item.authIcon"></i>
              <span>{{ item.authName }}</span>
            </template>
            <el-menu-item v-for="(items) in item.children || []" :key="items.authId" :index="items.authRemark"
              :route="items.authUrl">
              <i :class="items.authIcon"></i>
              <span slot="title">{{ items.authName }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
        <!-- <el-menu-item index="userList" route="/Home/userList">
          <i class="el-icon-monitor"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="department" route="/Home/department">
          <i class="el-icon-monitor"></i>
          <span>部门管理</span>
        </el-menu-item>
        <el-menu-item index="role" route="/Home/role">
          <i class="el-icon-monitor"></i>
          <span>角色管理</span>
        </el-menu-item>
        <el-menu-item index="authority" route="/Home/authority">
          <i class="el-icon-monitor"></i>
          <span>角色管理</span>
        </el-menu-item> -->
        <!--      
      <el-menu-item index="11">
        <i class="el-icon-user"></i>
        <span>用户管理</span>
        <el-badge type="danger" class="admin-badge">管理员</el-badge>
      </el-menu-item>
      <el-menu-item index="12">
        <i class="el-icon-menu"></i>
        <span>系统日志</span>
        <el-badge type="primary" class="admin-badge">管理员</el-badge>
      </el-menu-item> -->
      </el-menu>
    </el-aside>

    <!-- 右侧主内容区 -->
    <el-container>
      <!-- 顶部面包屑栏 -->
      <el-header class="home-header">
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item>
            <span class="breadcrumb-home" @click="goHome">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
            <span :class="{ 'breadcrumb-active': index === breadcrumbList.length - 1 }">{{ item }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 右侧用户信息 -->
        <div class="header-right">
          <!-- 消息通知 -->
          <el-popover
            placement="bottom-end"
            :width="360"
            trigger="click"
            popper-class="notice-popover"
            v-model="noticePopoverVisible"
            @show="handleNoticeShow"
          >
            <div class="notice-container" slot="reference">
              <el-badge :value="unReadNum" :hidden="unReadNum === 0" :max="99" class="notice-badge">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                </svg>
              </el-badge>
            </div>
            <!-- 消息列表 -->
            <div class="notice-list-wrapper">
              <div class="notice-header">
                <span class="notice-title">通知消息</span>
                <div class="notice-actions">
                  <el-button type="text" size="small" @click="handleReadAll" v-if="unReadNum > 0">全部已读</el-button>
                </div>
              </div>
              <div class="notice-list" v-loading="noticeLoading">
                <div v-if="noticeList.length === 0" class="notice-empty">
                  <i class="el-icon-bell"></i>
                  <span>暂无通知</span>
                </div>
                <div
                  v-for="item in noticeList"
                  :key="item.noticeId"
                  class="notice-item"
                  :class="{ 'is-read': item.noticeStatus === 1 }"
                  @click="handleNoticeClick(item)"
                >
                  <div class="notice-item-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                    </svg>
                  </div>
                  <div class="notice-item-content">
                    <div class="notice-item-title">{{ item.noticeTitle }}</div>
                    <div class="notice-item-desc">{{ item.noticeContent }}</div>
                    <div class="notice-item-time">{{ item.createtime }}</div>
                  </div>
                  <div class="notice-item-actions" @click.stop>
                    <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDeleteNotice(item.noticeId)" title="删除"></el-button>
                  </div>
                </div>
              </div>
              <div class="notice-footer" v-if="noticeList.length > 0">
                <el-button type="text" size="small" @click="goToNoticePage">查看全部</el-button>
              </div>
            </div>
          </el-popover>

          <el-button type="text" class="feedback-btn" @click="openFeedbackDialog">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
            </svg>
            <span>反馈</span>
          </el-button>
          <span class="header-user">{{ userInfo.auName || '用户' }}</span>
        </div>
      </el-header>

      <!-- 内容展示区（含keep-alive+router-view） -->
      <el-main class="home-main">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="420px" append-to-body :close-on-click-modal="false">
      <el-form :model="passwordForm" label-width="100px" size="small">
        <el-form-item label="旧密码">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入旧密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSavePassword">确定</el-button>
      </span>
    </el-dialog>

    <!-- 反馈弹窗 -->
    <FeedbackDialog ref="feedbackDialog" />

    <!-- 通知列表弹窗 -->
    <el-dialog title="通知消息" :visible.sync="noticeDialogVisible" width="700px" append-to-body>
      <div class="notice-all-wrapper" v-loading="noticeAllLoading">
        <div class="notice-all-header">
          <el-button type="primary" size="small" @click="handleReadAll" v-if="noticeAllList.some(item => item.noticeStatus !== 1)">全部已读</el-button>
        </div>
        <el-table :data="noticeAllList" border stripe style="width: 100%">
          <el-table-column prop="noticeTitle" label="标题" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="noticeContent" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createtime" label="发布时间" width="160"></el-table-column>
          <el-table-column prop="noticeStatus" label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.noticeStatus === 1 ? 'info' : 'danger'" size="small">
                {{ scope.row.noticeStatus === 1 ? '已读' : '未读' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleReadOneNotice(scope.row)" v-if="scope.row.noticeStatus !== 1">标记已读</el-button>
              <el-button type="text" size="small" @click="handleDeleteOneNotice(scope.row.noticeId)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleNoticeSizeChange"
          @current-change="handleNoticeCurrentChange"
          :current-page="noticePagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="noticePagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="noticePagination.total"
          style="margin-top: 15px; text-align: right;"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { active, create } from 'sortablejs';
import {
  getAjUserDetailsRefresh,
  updateAjUserPw,
  getSysNoticeList,
  getSysNoticeUnReadNum,
  updateSysNoticeRead,
  updateSysNoticeReadAll,
  deleteSysNoticeRead
} from "../api/api";
import FeedbackDialog from "../components/FeedbackDialog/FeedbackDialog.vue";
export default {
  name: "Home",
  components: {
    FeedbackDialog
  },
  data() {
    return {
      myRouter: [],
      clickRouter: '',
      isCollapse: false, // 控制侧边栏收缩状态
      hasContent: false, // 控制是否显示"暂无课程"
      userInfo: {
        auHeader: '',
        auName: '',
        auPostName: ''
      },
      // 修改密码弹窗
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      // 消息通知
      noticePopoverVisible: false,
      noticeLoading: false,
      noticeList: [],
      unReadNum: 0,
      // 查看全部通知弹窗
      noticeDialogVisible: false,
      noticeAllList: [],
      noticeAllLoading: false,
      noticePagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    document.title = "智课通";
    getAjUserDetailsRefresh().then(res => {
      if (res) {
        this.myRouter = res.data.ajRoleAuthList;
        // 保存用户信息
        this.userInfo = {
          auHeader: res.data.auHeader || '',
          auName: res.data.auName || '',
          auPost: res.data.auPost || '',
          auPostName: res.data.auPostName || '',
          adId: res.data.adId || '' // 部门ID
        };
        // 将用户信息保存到 localStorage
        localStorage.setItem('zhikeTong_userInfo', JSON.stringify(this.userInfo));
        console.log(this.userInfo);
        const clickRouter = localStorage.getItem('zhikeTong_path')
        if (this.myRouter && clickRouter) {
          this.clickRouter = clickRouter
          this.$router.push(clickRouter);
          // window.close();
        } else {
          const path = res.data.ajRoleAuthList[0].children ? res.data.ajRoleAuthList[0].children[0].authUrl : res.data.ajRoleAuthList[0].authUrl
          this.$router.push(path);
          // window.close();
        }
      }
    });
    // 获取未读消息数量
    this.getUnReadNum();
  },
  computed: {
    // 动态计算面包屑列表（使用菜单的 authName）
    breadcrumbList() {
      const currentPath = this.$route.path;
      const list = [];

      // 遍历菜单树查找当前路径
      if (this.myRouter && this.myRouter.length > 0) {
        this.myRouter.forEach(menu => {
          // 检查一级菜单
          if (menu.authUrl && currentPath.includes(menu.authUrl)) {
            list.push(menu.authName);
          }
          // 检查二级菜单
          if (menu.children && menu.children.length > 0) {
            menu.children.forEach(sub => {
              if (sub.authUrl && currentPath === sub.authUrl) {
                list.push(menu.authName);
                list.push(sub.authName);
              }
            });
          }
        });
      }

      // 如果没找到，使用路由 meta.title 或 name
      if (list.length === 0) {
        const matched = this.$route.matched;
        matched.forEach(route => {
          if (route.meta && route.meta.title) {
            list.push(route.meta.title);
          } else if (route.name) {
            list.push(route.name);
          }
        });
        // 过滤掉"Home"或首页
        return list.filter(item => item !== 'Home' && item !== '首页');
      }

      return list;
    }
  },
  actived() {
  },
  methods: {
    // 获取头像文字
    getAvatarText(name) {
      if (!name) return '用户';
      const len = name.length;
      if (len <= 2) return name;
      return name.substring(len - 2);
    },

    // 返回首页
    goHome() {
      if (this.myRouter && this.myRouter.length > 0) {
        const path = this.myRouter[0].children ? this.myRouter[0].children[0].authUrl : this.myRouter[0].authUrl;
        this.$router.push(path);
      }
    },

    // 打开修改密码弹窗
    openPasswordDialog() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.passwordDialogVisible = true;
    },

    // 保存新密码
    async handleSavePassword() {
      if (!this.passwordForm.oldPassword) {
        this.$message.warning('请输入旧密码');
        return;
      }
      if (!this.passwordForm.newPassword) {
        this.$message.warning('请输入新密码');
        return;
      }
      if (this.passwordForm.newPassword.length < 6) {
        this.$message.warning('新密码长度不能少于6位');
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.warning('两次输入的密码不一致');
        return;
      }
      try {
        await this.$confirmDialog({
          content: '确认修改密码吗？',
          type: 'success'
        });
        const res = await updateAjUserPw({
          auPw: this.passwordForm.newPassword,
          auPwOld: this.passwordForm.oldPassword
        });
        if (res.status === 200) {
          this.$message.success('密码修改成功，请重新登录');
          this.passwordDialogVisible = false;
          this.Out();
        } else {
          this.$message.error(res.msg || '密码修改失败');
        }
      } catch {
        // 取消
      }
    },

    Out() {
      localStorage.clear();
      this.$router.push({
        path: "/doLogin",
      });
    },
    handlePictureCardPreview() {
      // 子组件调用的方法（根据实际需求实现）
    },
    // 菜单点击事件（添加选中效果）
    handleMenuSelect(key) {
      // 1. 清空所有菜单项的选中样式
      localStorage.setItem('zhikeTong_path', key);

    },
    // 切换侧边栏收缩状态
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    // 打开反馈弹框
    openFeedbackDialog() {
      this.$refs.feedbackDialog.show();
    },

    // 获取未读消息数量
    async getUnReadNum() {
      try {
        const res = await getSysNoticeUnReadNum();
        if (res.status === 200) {
          // 接口返回的是数组，取长度作为未读数量
          this.unReadNum = res.data ? res.data.length : 0;
        }
      } catch (error) {
        console.error("获取未读消息数量失败:", error);
      }
    },

    // 打开消息弹窗时获取列表
    handleNoticeShow() {
      this.getNoticeList();
    },

    // 获取消息列表
    async getNoticeList() {
      this.noticeLoading = true;
      try {
        const res = await getSysNoticeList({
          currentPage: 1,
          pageSize: 10
        });
        if (res.status === 200) {
          this.noticeList = res.data || [];
        }
      } catch (error) {
        console.error("获取消息列表失败:", error);
      } finally {
        this.noticeLoading = false;
      }
    },

    // 点击消息项
    async handleNoticeClick(item) {
      if (item.noticeStatus !== 1) {
        await this.handleReadOne(item.noticeId);
      }
    },

    // 单条已读
    async handleReadOne(noticeId) {
      try {
        const res = await updateSysNoticeRead({ noticeIds: noticeId });
        if (res.status === 200) {
          // 更新本地状态
          const item = this.noticeList.find(n => n.noticeId === noticeId);
          if (item) {
            item.noticeStatus = 1;
          }
          this.getUnReadNum();
        }
      } catch (error) {
        console.error("标记已读失败:", error);
      }
    },

    // 全部已读
    async handleReadAll() {
      try {
        const res = await updateSysNoticeReadAll();
        if (res.status === 200) {
          this.$message.success("已全部标记为已读");
          // 更新下拉列表
          this.noticeList.forEach(item => {
            item.noticeStatus = 1;
          });
          // 更新弹窗列表
          this.noticeAllList.forEach(item => {
            item.noticeStatus = 1;
          });
          this.unReadNum = 0;
        }
      } catch (error) {
        console.error("一键已读失败:", error);
      }
    },

    // 删除消息
    async handleDeleteNotice(noticeId) {
      try {
        await this.$confirmDialog({
          content: "确认删除该消息吗？",
          type: "warning"
        });
        const res = await deleteSysNoticeRead({ noticeIds: noticeId });
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.getNoticeList();
          this.getUnReadNum();
        }
      } catch {
        // 取消
      }
    },

    // 查看全部消息 - 弹窗显示全部通知
    goToNoticePage() {
      this.noticePopoverVisible = false;
      this.noticeDialogVisible = true;
      this.noticePagination.currentPage = 1;
      this.getNoticeAllList();
    },

    // 获取全部通知列表
    async getNoticeAllList() {
      this.noticeAllLoading = true;
      try {
        const res = await getSysNoticeList({
          currentPage: this.noticePagination.currentPage,
          pageSize: this.noticePagination.pageSize
        });
        if (res.status === 200) {
          this.noticeAllList = res.data || [];
        }
      } catch (error) {
        console.error("获取通知列表失败:", error);
      } finally {
        this.noticeAllLoading = false;
      }
    },

    // 通知列表分页大小改变
    handleNoticeSizeChange(val) {
      this.noticePagination.pageSize = val;
      this.getNoticeAllList();
    },

    // 通知列表当前页改变
    handleNoticeCurrentChange(val) {
      this.noticePagination.currentPage = val;
      this.getNoticeAllList();
    },

    // 通知列表单条已读
    async handleReadOneNotice(row) {
      try {
        const res = await updateSysNoticeRead({ noticeIds: row.noticeId });
        if (res.status === 200) {
          row.noticeStatus = 1;
          this.getUnReadNum();
          this.$message.success("标记已读成功");
        }
      } catch (error) {
        console.error("标记已读失败:", error);
      }
    },

    // 通知列表删除
    async handleDeleteOneNotice(noticeId) {
      try {
        await this.$confirmDialog({
          content: "确认删除该通知吗？",
          type: "warning"
        });
        const res = await deleteSysNoticeRead({ noticeIds: noticeId });
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.getNoticeAllList();
          this.getUnReadNum();
        }
      } catch {
        // 取消
      }
    },
  }
};
</script>

<style scoped>
.el-card__body,
.el-main {
  padding: 0 !important;
}

.is-active {
  background-color: #eff6ff !important;
  color: #409EFF !important;
  font-weight: bold;
}

/* 左侧侧边栏 */
.home-aside {
  background: #fff;
  border-right: 1px solid #e6e6e6;
  height: 100%;
  overflow-y: auto;
  transition: width 0.3s ease;
}

/* Logo + 用户信息 */
.aside-header {
  padding: 16px 12px;
  border-bottom: 1px solid #e6e6e6;
  text-align: center;
  position: relative;
}

/* 用户信息卡片 */
.user-info-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
}

/* 卡片顶部用户信息 */
.user-info-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

/* 操作按钮组 */
.action-buttons-group {
  display: flex;
  gap: 8px;
}

/* 操作按钮 */
.action-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  border: none;
}

.action-btn svg {
  flex-shrink: 0;
}

/* 修改密码按钮 */
.password-btn {
  background: #fff;
  color: #64748b;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.password-btn:hover {
  background: #f8fafc;
  color: #409EFF;
  border-color: #409EFF;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.15);
}

/* 退出登录按钮 */
.logout-btn {
  background: #fff;
  color: #64748b;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.logout-btn:hover {
  background: #fef2f2;
  color: #ef4444;
  border-color: #fecaca;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(239, 68, 68, 0.15);
}

/* 收缩按钮容器 */
.collapse-btn-wrapper {
  position: absolute;
  top: 8px;
  right: 8px;
}

/* 收缩按钮样式 */
.collapse-btn {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
  color: #94a3b8;
  background: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
}

.collapse-btn:hover {
  background: #fff;
  color: #409EFF;
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
}

/* 收缩状态下的样式 */
.home-aside.is-collapse .aside-header {
  padding: 15px 5px;
}

.home-aside.is-collapse .logo {
  justify-content: center;
  flex-wrap: nowrap;
}

.home-aside.is-collapse .logo-icon-wrapper {
  margin-right: 0;
  flex-shrink: 0;
}

.home-aside.is-collapse .logo-text {
  display: none;
}

.home-aside.is-collapse .user-text {
  display: none;
}

.home-aside.is-collapse .header-actions {
  display: none;
}

/* 收缩状态 - 隐藏用户卡片 */
.home-aside.is-collapse .user-info-card {
  display: none !important;
}

/* 收缩状态下 - logo区域的收缩按钮容器 */
.home-aside.is-collapse .logo .collapse-btn-wrapper {
  position: static;
  transform: none;
  margin-left: 0;
  margin-top: 0;
}

/* 收缩状态下 - 用户卡片区域的收缩按钮 */
.home-aside.is-collapse .user-info-card > .collapse-btn-wrapper {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

.logo {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
}

/* Logo区域收缩按钮容器 */
.logo .collapse-btn-wrapper {
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
}

/* 收缩状态下logo区域的收缩按钮 */
.home-aside.is-collapse .logo > .collapse-btn-wrapper {
  position: static;
  transform: none;
  margin-left: 0;
  margin-top: 0;
  flex-shrink: 0;
}

/* Logo图标 */
.logo-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  margin-right: 10px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  flex-shrink: 0;
}

.logo-icon-wrapper svg {
  color: #fff;
}

.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 1px;
}

.user-info-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
}

.user-avatar-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.user-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.user-avatar-text {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.user-text {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.user-role {
  font-size: 12px;
  color: #64748b;
}

/* 岗位徽章 */
.post-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* 岗位1 - 紫色渐变 */
.post-1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

/* 岗位2 - 蓝色渐变 */
.post-2 {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: #fff;
}

/* 岗位3 - 绿色渐变 */
.post-3 {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
}

/* 岗位4 - 橙红色渐变 */
.post-4 {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
}

/* 默认岗位样式 */
.post-0 {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
  color: #fff;
}

/* 菜单样式（完全还原图3） */
.aside-menu {
  border-right: none;
  margin-top: 10px;
}

/* 收缩状态下的菜单样式 */
.home-aside.is-collapse .aside-menu:not(.el-menu--collapse) {
  width: 64px;
}

.el-menu--collapse {
  width: 64px;
}

.el-menu--collapse .el-menu-item,
.el-menu--collapse .el-submenu__title {
  padding: 0 !important;
  text-align: center;
}

.el-menu--collapse .el-menu-item span,
.el-menu--collapse .el-submenu__title span {
  display: none;
}

.el-menu--collapse .el-menu-item i,
.el-menu--collapse .el-submenu__title i {
  margin-right: 0;
}

.el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding-left: 20px !important;
  transition: all 0.2s ease;
}

/* 菜单图标（匹配图3的图标样式） */
.el-menu-item i,
.el-submenu__title i {
  font-size: 16px;
  margin-right: 8px;
}

/* 菜单选中效果（图3的浅蓝色背景+蓝色文字） */
.menu-active,
.el-menu-item:hover {
  background-color: #e6f7ff !important;
  color: #409EFF !important;
}

.el-menu-item.menu-active i,
.el-menu-item:hover i {
  color: #409EFF !important;

}

/* 子菜单样式（缩进+匹配图3） */
.el-submenu .el-menu-item {
  padding-left: 40px !important;
}

/* 整体布局 */
.home-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}



.admin-badge {
  margin-left: 5px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  padding: 0 5px;
}

.aside-menu {
  border-right: none;
}

.el-submenu__title,
.el-menu-item {
  height: 40px;
  line-height: 40px;
}

/* 右侧主内容区 */
.home-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e6e6e6;
  height: 60px;
}

.org-info {
  font-size: 14px;
  color: #666;
}

.org-name {
  font-weight: 500;
  color: #333;
}

.breadcrumb {
  flex: 1;
  display: flex;
  align-items: center;
}

.breadcrumb-home {
  cursor: pointer;
  color: #64748b;
  transition: color 0.2s;
}

.breadcrumb-home:hover {
  color: #409EFF;
}

.breadcrumb-active {
  color: #1e293b;
  font-weight: 500;
}

/* 右侧用户信息 */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-user {
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 反馈按钮 */
.feedback-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 6px;
  color: #64748b;
  font-size: 13px;
  transition: all 0.25s ease;
}

.feedback-btn:hover {
  background: #f0f9eb;
  color: #67c23a;
}

.feedback-btn svg {
  color: currentColor;
}

.service-status {
  font-size: 14px;
}

/* 内容区 */
.home-main {
  /* padding: 20px; */
  overflow: hidden;
  height: calc(100vh - 60px);
  background: #f9fafb;
}

.category-bar {
  margin-bottom: 20px;
}



.el-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.expand-btn {
  color: #409EFF;
  padding: 0;
}

.content-area {
  min-height: 300px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.empty-icon {
  font-size: 40px;
  color: #ccc;
  margin-bottom: 10px;
}

.empty-content {
  text-align: center;
  color: #999;
}

/* 消息通知样式 */
.notice-container {
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  color: #64748b;
  transition: all 0.25s ease;
}

.notice-container:hover {
  background: #f0f9eb;
  color: #67c23a;
}

.notice-container svg {
  color: currentColor;
}

.notice-badge /deep/ .el-badge__content {
  top: -2px;
  right: -2px;
}

.notice-list-wrapper {
  margin: -12px;
}

.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.notice-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.notice-actions {
  display: flex;
  gap: 8px;
}

.notice-list {
  max-height: 360px;
  overflow-y: auto;
}

.notice-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #909399;
}

.notice-empty i {
  font-size: 40px;
  margin-bottom: 10px;
}

.notice-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f5f5f5;
}

.notice-item:hover {
  background: #f5f7fa;
}

.notice-item.is-read {
  background: #fafafa;
}

.notice-item.is-read .notice-item-title {
  color: #909399;
}

.notice-item-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9eb;
  border-radius: 50%;
  color: #67c23a;
  margin-right: 12px;
}

.notice-item-content {
  flex: 1;
  min-width: 0;
}

.notice-item-title {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-item-desc {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-item-time {
  font-size: 12px;
  color: #909399;
}

.notice-item-actions {
  flex-shrink: 0;
  margin-left: 8px;
  opacity: 0;
  transition: opacity 0.2s;
}

.notice-item:hover .notice-item-actions {
  opacity: 1;
}

.notice-footer {
  text-align: center;
  padding: 10px;
  border-top: 1px solid #f0f0f0;
}

/* 通知列表弹窗样式 */
.notice-all-wrapper {
  min-height: 300px;
}

.notice-all-header {
  margin-bottom: 15px;
}
</style>